"use client";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";

const NavHeading = () => {
  const pathname = usePathname();
  const [show, setShow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY < 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Only render if pathname is exactly '/'
  if (pathname !== "/") {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: show ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      className="hidden md:flex fixed top-4 left-1/2 -translate-x-1/2 z-40 pointer-events-none bg-white/50 backdrop-blur-md px-8 py-3 rounded-lg shadow-xl w-[520px] max-w-[90%] items-center space-x-4"
    >
      <Image
        src="/QQQ.webp"
        alt="Design Nook Logo"
        width={100}
        height={100}
        priority
        className="hidden sm:block"
      />

      {/* Vertical divider */}
      <div className="h-20 w-[2px] bg-[#A65D5D] rounded" />

      <h1 className="text-5xl lg:text-6xl font-serif text-[#A65D5D] font-semibold tracking-tight">
        Design Nook
      </h1>
    </motion.div>
  );
};

export default NavHeading;
